export default "__VITE_ASSET__Dpi0Ad2S__"